/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:15:56
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare খুলুন",
    name2: "সংরক্ষণ করুন",
    name3: "Carlcare এর সাথে, আপনি আপনার অর্ডার যেকোনো সময়ে দেখতে পারেন।",
    name4: "",
    name5: "ডানে স্লাইড করুন",
    name6: "যাচাইকরণ সম্পন্ন হয়েছে",
  },
  order: {
    name1: "ডিভাইসের মডেল নির্বাচন করুন",
    name2: "সমস্যার বিবরণ:",
    name3: "পরিষেবা স্টোর নির্বাচন করতে ট্যাপ করুন",
    name4: "পরিষেবা স্টোর:",
    name5: "সংরক্ষণের সময়:",
    name6: "অনুগ্রহ করে আপনার ডিভাইসটির সমস্যা বিশদে জানান!",
    name7: "আগমনের সময় নির্বাচন করতে ট্যাপ করুন",
    name8: "অনুগ্রহ করে আপনার সাথে যোগাযোগের সঠিক তথ্য দিন যাতে আমরা আপনার সাথে যোগাযোগ করতে পারি",
    name9: "নিম্নলিখিত রিজার্ভেশনের সময় উপলব্ধ",
    name10: "অনুগ্রহ করে আপনার ফোন নাম্বারটি প্রবেশ করান",
    name11: "মূল্য",
    name12: "ব্যক্তিগত তথ্য:",
    name13: "দয়া করে আপনার নাম লিখুন",
    name14: "জমা দিন",
    name15: "বাতিল করুন",
    name16: "ঠিক আছে",
  },
  shops: {
    name1: "আপনার নির্বাচন করা ব্র্যান্ডের ভিত্তিতে, নিম্নলিখিত স্টোরগুলি আপনাকে পরিষেবা দিতে পারে!",
    name2: "আরও অনেক খুচরো বিক্রেতার দোকানে আসছে! আমাদের সাথে থাকুন!",
  },
  price: {
    name1: "মার্কা",
    name2: "মডেল",
    name3: "পদ",
    name4: "মূল্য",
    name5: "বন্ধুত্বপূর্ণ অনুস্মারক:",
    name6: "এই মূল্যগুলি আনুমানিক, এবং আসল মূল্য আপনার ডিভাইসের অবস্থার উপরে নির্ভরশীল।",
    name7: "কোনও বিশেষ চিহ্ন না থাকলে, মূল্যের একক হল স্থানীয় মুদ্রার মান।",
    name8: "দুঃখিত! বর্তমান এই অঞ্চলে কোনো মূল্যের তথ্য নেই।",
    name11:"শ্রমিকের খরচ",
    name12:"মোট দাম",
    name13: "5. শ্রমিকের খরচ যদি \"/\" হয়, তার মানে স্টোরের সাথে শ্রমিকের খরচ পরামর্শ করে নেয়া প্রয়োজন।",
    item_main_board: "মেইনবোর্ড",
    item_screen_frame: "স্ক্রিন (ফ্রেম)",
    item_screen_screen_frame: "সেকেন্ডারি স্ক্রিন (ফ্রেম) ",
    item_touch_screen: "টাচ স্ক্রিন ",
    item_camera: "ক্যামেরা",
    item_fixed_focus_camera: "স্থির ফোকাস ক্যামেরা",
    item_auto_focus_camera: "অটো ফোকাস ক্যামেরা",
    item_screen: "স্ক্রিন",
    item_secondary_screen: "সেকেন্ডারি স্ক্রিন ",
    item_fingerprint_module: "ফিঙ্গারপ্রিন্ট মডিউল ",
    item_speaker: "স্পিকার ",
    item_receiver: "রিসিভার",
    item_small_board: "ছোট বোর্ড",
    item_battery_cover: "ব্যাটারি কভার",
    item_battery: "ব্যাটারি",
    item_charger: "চার্জার",
    item_usb_cable: "ইউএসবি কেবল",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "কোন ডেটা নেই",
    name2: "পরিষেবা প্রদানকারী:",
    name3: "সেবার ব্যান্ড:",
    name4: "টেলিফোন:",
    name5: "অর্ডারের পরিমাণ:",
    name6: "পরিষেবার রেটিং",
    name7: "পরিষেবার পরিবেশ:",
    name8: "পরিষেবার মনোভাব:",
    name9: "পরিষেবার দক্ষতা:",
    name10: "পরিষেবার গুণমান:",
    name11: "ক্রেতা মূল্যায়ন",
    name12:"থেকে",
    name13:"বন্ধ করা হয়েছে",
  },
  reserSuccess: {
    // name1:
    //   "Carlcare খুলুন",
    name1: "অগ্রাধিকার পরিষেবা পেতে অনুগ্রহ করে রিসিট হিসেবে রিজার্ভেশনের তথ্যটির স্ক্রিনশট নিয়ে সেভ করে রাখুন।",
    name2: "সফলভাবে জমা করা হয়েছে",
    name3: "1. ডেটা ক্লিন করুন",
    name4: "আগের থেকেই আপনার ফোনে গুরুত্বপূর্ণ ব্যক্তিগত ডেটা ব্যাকআপ করে রাখুন",
    name5: "2. পাওয়ার-অন পাসওয়ার্ড নিষ্ক্রিয় করুন",
    name6: "পরিষেবা কেন্দ্রে যাওয়ার আগে, দয়া করে:",
    name7: "পরিষেবা স্টোর:",
    name8: "সংরক্ষণের সময়:",
    name9: "সমস্যার বিবরণ:",
    name10: "ডিভাইস মডেল:",
    name11: "অর্ডার নম্বর:", 
    name12: "তথ্য অর্ডার করুন",
  },
  title: {
    name1: "এই দেশগুলি সমর্থিত:",
    name2: "মডেল পছন্দ করুন",
    name3: "সংরক্ষণ",
    name4: "পরিষেবা স্টোরের বিবরণ",
    name5: "পরিষেবা স্টোর নির্বাচন করুন",
  },
  error: {
    name1: "কোনো ডেটা নেই। অনুগ্রহ করে আপনার মেরামতের তথ্য চেক করুন",
    name2: "আরো বেশি সাহায্যের প্রয়োজন? অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন।",
    name3: "দুঃখিত, বর্তমান অঞ্চলে কোনো Carlcare কেন্দ্র নেই।",
    name4: "অনুগ্রহ করে আগে একটি পরিষেবা কেন্দ্র বাছুন",
    name5: "ব্যর্থ হয়েছে",
    name6: "অনুগ্রহ করে আগে একটি ডিভাইস মডেল বাছুন",
    name7: "বিশদ বিবরণ",
    name8: "অনুগ্রহ করে আপনার প্রয়োজন বিশদে জানান",
    name9: "",
  },
  add1:{
    "name0": "bn-rBD",
    "name1": "আপনার অর্ডারটি নিশ্চিত করা হয়েছে। আমরা আপনার আগমনের অপেক্ষায় রয়েছি।",
    "name2": "শহর নির্বাচন করুন",
    "name3": "প্লিজ %1$s সংখ্যার একটি ফোন নম্বর ইনপুট দিন",
    "name4": "সপ্তাহের দিন ঘন্টা",
    "name5": "সোমবার",
    "name6": "মঙ্গলবার",
    "name7": "বুধবার",
    "name8": "বৃহস্পতিবার",
    "name9": "শুক্রবার",
    "name10": "শনিবার",
    "name11": "রবিবার",
    "name12": "দেশের নাম লিখুন এবং অনুসন্ধান করুন"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "অন্যান্য",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"রিডিরেক্টের জন্য ট্যাপ করুন",
    name3:"অর্ডার রেট করতে Carlcare অ্যাপ খুলুন",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"পরিষেবা নির্বাচন করুন",
    name7:"বিনামূল্যে পরিষ্কার",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ভুল তথ্য",
    "cancelReason1": "সঠিক সময়ে এসে পৌঁছাতে পারছে না",
    "cancelReason2": "নকল অর্ডার/আমার অর্ডার নয়",
    "cancelReason3": "ব্যর্থতার পুনরাবৃত্তি হয় না",
    "cancelReason4": "শুধু পরীক্ষা/অনুসন্ধান/ইভেন্ট/-এর জন্য…",
    "cancelReason5": "বেশি দাম",
    "cancelReason6": "উপাদানের ঘাটতি",
    "cancelReason7": "কোনো বিভেদমূলক পরিষেবা প্রদান করা হয় না",
    "cancelReason8": "স্টোরটি অনেক দূরে",
    "cancelReason9": "স্টোরটি বন্ধ আছে",
    "cancelReason10": "গ্রাহক পরিষেবার খারাপ ব্যবহার",
    "cancelReason11": "অন্যান্য ব্র্যান্ডের জন্য প্রতিস্থাপন করা/মেরামত করা",
    "cancelReason12": "দোকান খুঁজে পাওয়া যাচ্ছে না",
    "cancelReason13": "অন্যান্য",
    "cancelOrder": "অর্ডার বাতিল করুন",
    "reason_dialog_title": "অনুগ্রহ করে বাতিলকরণের কারণটি আমাদের বলুন",
    "Cancel": "বাতিল করুন",
    "OK": "ঠিক আছে",
    "name1": "যাচাইকরণ কোডটি লিখুন",
    "name2": "অবৈধ যাচাই কোড",
    "repair_reservation_detail_canceled": "এই অর্ডার বাতিল করা হয়েছে!",
    "purchase_cancel_dialog_content": "আপনি কি অর্ডারটি বাতিল করতে নিশ্চিত?",
    "yes": "হ্যা",
    "no": "না"
},
onSiteService:{
  "name1": "দোকানের ভিতরে মেরামত",
  "name2": "অন-সাইট পরিষেবা",
  "name3": "অন-সাইট পরিষেবা পাওয়ার জন্য আপনার লোকেশন চালু করতে হবে। অনুগ্রহ করে এটি চালু করুন এবং আবার চেষ্টা করুন।",
  "name4": "আপনার অবস্থান নির্বাচন করুন:",
  "name5": "স্থানীয় অর্ডার",
  "name6": "বর্তমান লোকেশন:",
  "name7": "ঠিকানা:",
  "name8": "নাম",
  "name9": "টেলিফোন:"
}
};
